import React, { useEffect, useState } from 'react';
import { Badge, ConfigProvider, Flex, Menu, MenuProps, message, Space, Typography } from 'antd';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { historicDevicePath, summaryDevicePath } from '../../routes';
import './DeviceDetailPage.scss';
import { useDeviceStore } from '../../stores/device.store';
import AlertComponent from '../../components/device/SummaryComponents/AlertComponent/AlertComponent';
import { useTelemetryStore } from '../../stores/telemetry.store';
import { Device } from '../../gen/proto/api/gateway/v1/gateway_pb';

const { Title } = Typography;
type MenuItem = Required<MenuProps>['items'][number];
const INTERVAL_REFRESH_MS = 2000;

const DeviceDetailPage = () => {
  const { deviceUuid } = useParams() as { deviceUuid: string };
  const [messageApi, contextHolder] = message.useMessage();

  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.split('/').pop();
  const [current, setCurrent] = useState(currentPath || summaryDevicePath);

  const getDeviceByUuid = useDeviceStore((state) => state.getByUuid);
  const [device, setDevice] = useState<Device | null>(null);

  const getActualTelemetryData = useTelemetryStore((state) => state.getActualTelemetryData);
  const [deviceAlert, setDeviceAlert] = useState('N/A');

  useEffect(() => {
    const fetchDevice = async () => {
      try {
        await getDeviceByUuid(deviceUuid).then((device) => {
          setDevice(device);
        });
        const deviceData = await getActualTelemetryData(deviceUuid);
        setDeviceAlert(deviceData?.alert ?? 'N/A');
      } catch (error) {
        messageApi.error((error as Error).message);
      }
    };
    fetchDevice();
  }, [deviceUuid, getDeviceByUuid, getActualTelemetryData, messageApi]);

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const deviceData = await getActualTelemetryData(deviceUuid);
        setDeviceAlert(deviceData?.alert ?? 'N/A');
      } catch (error) {
        messageApi.error((error as Error).message);
      }
    }, INTERVAL_REFRESH_MS);
    return () => clearInterval(interval);
  }, [deviceUuid, getActualTelemetryData, messageApi]);

  const items: MenuItem[] = [
    {
      label: 'Resumen',
      key: summaryDevicePath,
    },
    {
      label: 'Histórico',
      key: historicDevicePath,
    },
  ];

  const onClick: MenuProps['onClick'] = (e) => {
    setCurrent(e.key);
    const newPath = location.pathname.split('/').slice(0, -1).join('/');
    navigate(`${newPath}/${e.key}`);
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Badge: {
            statusSize: 20,
          },
          Menu: {
            fontSize: 14,
          },
        },
      }}
    >
      <Flex vertical className={'DeviceDetailPage'}>
        {contextHolder}
        <Space className={'DeviceDetailPage__titleDiv'}>
          <div className={'DeviceDetailPage__badgeDiv'}>
            <Badge status={device?.data?.connected ? 'success' : 'error'} className={'DeviceDetailPage__badge'} />
            <Title level={1} className={'DeviceDetailPage__title'}>
              {`${device?.name ?? 'Dispositivo'} - ${device?.data?.type ?? 'Tipo'}`}
            </Title>
          </div>
          <AlertComponent value={deviceAlert} />
        </Space>
        <Menu onClick={onClick} selectedKeys={[current]} mode="horizontal" items={items} />
        <br />
        <Outlet />
      </Flex>
    </ConfigProvider>
  );
};

export default DeviceDetailPage;
